import React from 'react';
import { ChildrenPropType } from '../../prop-types/children';
import { LocaleContextProvider } from './index';
import { initialAvailableLocaleState } from './initial-state';
import { German } from './locale-codes';
import { CheckEnvService } from '../../services/check-env-service';

const areWeInDevEnvironment = CheckEnvService.areWeInDevEnvironment();

export const UnauthenticatedLocaleContextProvider = ({ children }) => {
  const availableLocales = [...initialAvailableLocaleState, ...(areWeInDevEnvironment ? [German] : [])];

  return <LocaleContextProvider availableLocales={availableLocales}>{children}</LocaleContextProvider>;
};

UnauthenticatedLocaleContextProvider.propTypes = {
  children: ChildrenPropType.isRequired,
};
